import Actions from "../store/actions";

/**
 * Adds the module name to the action value.
 *
 * If I had a module called 'fruit' with an action for fetching it, creating one and deleting one a fruit,
 *  my actions may look something like this:
 *
 *  FRUIT: {
 *    FETCH: 'FETCH',
 *    CREATE: 'CREATE',
 *    DELETE: 'DELETE'
 *  }
 *
 *  When I dispatch an action in the fruit module, I would call:
 *    this.$store.dispatch('fruit/FETCH').
 *
 *  This plugin creates an object of each action, prepended with the correct module. Using the above example:
 *
 *  FRUIT: {
 *    FETCH: 'fruit/FETCH',
 *    CREATE: 'fruit/CREATE',
 *    DELETE: 'fruit/DELETE'
 *  }
 *
 *  And appends a variable called '$action' to the Vue instance. This allows for quicker access to actions without
 *    the need to import them everywhere.
 *
 *  Final usage:
 *    this.$store.dispatch(this.$action.FRUIT.FETCH)
 */
const install = Vue => {
  const modules = {};
  Object.entries(Actions).forEach(([key, values]) => {
    const module = {};
    for (const value in values) {
      module[value] = `${key.toLowerCase()}/${value}`;
    }
    modules[key] = module;
  });
  Object.defineProperty(Vue.prototype, "$action", { value: modules });
};

export default {
  install
};
